import axiosClient from './axiosClient';
import createFormData from './formData';

const normalizeCategoryPayload = (payload = {}) => ({
  ...payload,
  parent_id: payload.parent_id || null,
  sort_order: payload.sort_order || 0,
  is_active: payload.is_active ? 1 : 0,
});

export const categoriesApi = {
  getCategories(establishmentId, params = {}) {
    return axiosClient.get(
      `/establishments/${establishmentId}/categories`,
      {
        params,
      },
    );
  },

  getActiveCategories(establishmentId, params = {}) {
    return axiosClient.get(
      `/establishments/${establishmentId}/categories`,
      {
        params: {
          is_active: 1,
          per_page: 100,
          ...params,
        },
      },
    );
  },

  getParentCategories(establishmentId, params = {}) {
    return axiosClient.get(
      `/establishments/${establishmentId}/categories`,
      {
        params: {
          is_active: 1,
          parent_only: 1,
          per_page: 100,
          ...params,
        },
      },
    );
  },

  getSubcategories(establishmentId, parentId, params = {}) {
    return axiosClient.get(
      `/establishments/${establishmentId}/categories`,
      {
        params: {
          is_active: 1,
          parent_id: parentId,
          per_page: 100,
          ...params,
        },
      },
    );
  },

  getCategoryTree(establishmentId, params = {}) {
    return axiosClient.get(
      `/establishments/${establishmentId}/categories`,
      {
        params: {
          is_active: 1,
          tree: 1,
          per_page: 100,
          ...params,
        },
      },
    );
  },

  getCategory(categoryId) {
    return axiosClient.get(`/categories/${categoryId}`);
  },

  createCategory(establishmentId, payload) {
    const formData = createFormData(
      normalizeCategoryPayload(payload),
    );

    return axiosClient.post(
      `/establishments/${establishmentId}/categories`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );
  },

  updateCategory(categoryId, payload) {
    const formData = createFormData({
      ...normalizeCategoryPayload(payload),
      _method: 'PUT',
    });

    return axiosClient.post(`/categories/${categoryId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  updateStatus(categoryId, isActive) {
    return axiosClient.patch(`/categories/${categoryId}/status`, {
      is_active: isActive ? 1 : 0,
    });
  },

  deleteCategory(categoryId) {
    return axiosClient.delete(`/categories/${categoryId}`);
  },
};

export default categoriesApi;